import React, { useEffect } from 'react';
import { Modal } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactGA from 'react-ga4';

import ScrollToTop from './ScrollToTop';
import LANDING from './LANDING';

ReactGA.initialize([{
	trackingId: 'G-1G56GWWNC9',
	debug: true,
	gtagOptions: {
		cookieDomain: 'auto',
 		allowAdFeatures: true
	},

}]);

ReactGA.event({
  category: "your category",
  action: "your action",
  label: "your label", // optional
  value: 99, // optional, must be a number
  nonInteraction: true, // optional, true/false
  transport: "xhr", // optional, beacon/xhr/image
});


export default () => {
	const [showSupportPopup, setShowSupportPopup] = React.useState(false);

	useEffect(() => {
        //ReactGA.pageview(window.location.pathname + window.location.search);
		ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search,title:"Cosway"});

 	});

	useEffect(() => {
        if (showSupportPopup) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [showSupportPopup]);

	return (
		<Router>
			<div id="content-wrapper">
				<nav className="navbar navbar-light navbar-expand-lg bg-primary">
					<div className="container">
						<div className="navbar-brand d-flex text-white clickable">
							<a href={process.env.MIX_INSTAPOL_DOMAIN}>
								<img className="instapol-logo" src="../images/new-logo-white.png" alt="Howden Insurance Brokers Sdn Bhd" loading="lazy" />
							</a>
						</div>
						<button className="navbar-toggler text-white border-0" type="button" data-toggle="collapse" data-target="#navbar">
							<i className="fas fa-bars" />
						</button>
						<div className="collapse navbar-collapse" id="navbar">
							<ul className="navbar-nav ml-auto">
								<li className="nav-item">
									<div className="row mt-2 mb-2">
										<div className="col-lg-4 align-self-end text-white text-right">
										</div>
										<div className="col-lg-4 align-self-end text-white text-right">
											<h5><b>Exclusively Designed for Cosway Members</b></h5>
										</div>
										<div className="col-lg-4 text-right">
										<img width={190} src="../images/Cosway Logo-01.png" alt="Howden Insurance Brokers Sdn Bhd" loading="lazy" />
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</nav>
				<ScrollToTop />
				<Switch>
					<Route exact path="/LANDING">
						<LANDING />
					</Route>
				</Switch>

				<div className="row">
					<div className="col-4 float-right btn-group-fab" role="group">
						<>
							<button type="button" className="btn btn-secondary" data-placement="left" title="Contact Us" onClick={() => setShowSupportPopup(true)}>
								<i className="fas fa-comment-alt"></i>
							</button>
						</>
					</div>
				</div>
			</div>
			<section id="footer" className="mt-4 mr-3">
				<div className="row">
					<div className="col-12">
						<footer id="home-footer">
							<div className="container">
								<div className="row">
									<div className="col-12 col-sm-6 text-center text-sm-left">
										<a href="#">
											<img src="../images/new-logo-02.png" id="instapol-logo" alt="Instapol" width={150} loading="lazy" />
										</a>
										<div className="d-flex row mt-3">
											<div className="col-4 col-sm-3 border-right">
												<a className="btn btn-link" href="https://www.howdengroup.com/my-en/privacy-and-data-protection">
													Privacy Notice
												</a>
											</div>
											<div className="col-4 col-sm-3 border-right">
												<a className="btn btn-link" href="https://instapol.my/refund-policy">
													Refund Policy
												</a>
											</div>
											<div className="col-4 col-sm-3">
												<a className="btn btn-link" href="https://www.howdengroup.com/my-en/terms-and-conditions">
													Terms &amp; Conditions
												</a>
											</div>
										</div>
										<p>Copyright &copy; 2021 Instapol. All rights reserved.</p>
									</div>
									<div className="col-12 col-sm-6 text-center text-sm-right mt-4 mt-sm-0">
										<p>Developed and owned by</p>
										<a href="#">
											<img src="../images/new-howden-logo-navy.png" id="howden-logo" alt="Howden Insurance Brokers Sdn Bhd" width={200} loading="lazy" />
										</a>
										<p className="mt-3 mb-0">Howden Insurance Brokers Sdn. Bhd. (197801001023)</p>
										<p>Howden Takaful Brokers Sdn. Bhd. (198001010734)</p>
									</div>
								</div>
							</div>
						</footer>
					</div>
				</div>
			</section>
			<Modal show={showSupportPopup} onHide={() => setShowSupportPopup(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Contact Us</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row text-dark-primary">
						<div className="col-10">
							<h5>WhatsApp:</h5>
							<a target="_blank" href={"https://api.whatsapp.com/send?phone=60122606183&text=" + process.env.MIX_APP_NAME}>+60122606183</a>
						</div>
					</div>
					<div className="row text-dark-primary">
						<div className="col-10">
							<h5>Email:</h5>
							<a href="mailto:insta.admin@howdengroup.com">insta.admin@howdengroup.com</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</Router>
	);
}